import React from 'react'
import HeaderInner from '../header/HeaderInner';
import ProjectDetails from './breadcrumb/ProjectDetails';
import Footer from '../elements/Footer';



function PortfolioSix() {
  return (
    <div>
        <HeaderInner/>
        <>
        <ProjectDetails/>

        {/* Start Projects Details area  */}
        <div className="projects-details-area tmp-section-gap">
            <div className="container">
            <div className="row">
                <div className="col-lg-12">
                <div className="projects-details-inner">
                    <div className="thumbnail position-relative">
                    <img
                        src="assets/images/projects-details/projects-details.jpg"
                        alt="projects-details"
                    />
                    </div>
                    <div className="clients-projects-details">
                    {/* <div className="clients-details-inner">
                        <h3 className="title text-center">CLIENT PROJECT DETAILS</h3>
                        <div className="single-projects-details">
                        <div className="info">
                            <div className="icon">
                            <i className="fa-solid fa-user" />
                            </div>
                            <div className="content">
                            <h4 className="subtitle">Clients:</h4>
                            <h5 className="category">GreenEdge Holdings</h5>
                            </div>
                        </div>
                        <div className="info">
                            <div className="icon">
                            <i className="fa-sharp fa-light fa-layer-group" />
                            </div>
                            <div className="content">
                            <h4 className="subtitle">Category:</h4>
                            <h5 className="category">Audit & Compliance Consulting</h5>
                            </div>
                        </div>
                        <div className="info">
                            <div className="icon">
                            <i className="fa-light fa-calendar-days" />
                            </div>
                            <div className="content">
                            <h4 className="subtitle">Date:</h4>
                            <h5 className="category">15 March 2024</h5>
                            </div>
                        </div>
                        <div className="info">
                            <div className="icon">
                            <i className="fa-regular fa-map-location" />
                            </div>
                            <div className="content">
                            <h4 className="subtitle">Address:</h4>
                            <h5 className="category">+91 9876543210</h5>
                            </div>
                        </div>
                        </div>
                    </div> */}
                    <div className="projects-details-wrapper">
                        <h3 style={{paddingTop:"65px"}} className="title">Financial Audit &amp; VAT Registration Support</h3>
                        <p style={{textAlign:"justify"}} className="description">
                       A comprehensive financial audit was conducted alongside the full VAT registration and compliance process. The internal finance division was supported to ensure proper alignment with statutory reporting standards. From documentation verification to ERP integration, the focus was on streamlining financial operations and maintaining compliance with evolving regulations. A process-driven approach and close attention to detail enhanced internal control and strengthened overall decision-making confidence.
                        </p>
                        <p style={{textAlign:"justify"}} className="description">
                        AQ Audit also delivered expert guidance to strengthen internal processes, enabling the business to prepare for future investment opportunities and expansion.


                        </p>
                    </div>
                    <div className="projects-details-wrapper">
                        <h3 className="title">The Challenge Of Project</h3>
                        <p style={{textAlign:"justify"}} className="description">
                        The client lacked a centralized ERP solution, had fragmented accounting records, and was unfamiliar with current VAT filing regulations. Our consultants conducted a thorough business review, realigned their reporting structure, and helped digitize their accounting practices. Strategic planning and focused execution ensured minimal business disruption and full compliance.
                        </p>
                        <div className="row">
                        <div className="col-lg-6">
                            <div className="challenge-details">
                            <div className="icon">
                                <i className="fa-solid fa-check" />
                            </div>
                            <p className="description">
                                It's essential to work with consultants who understand your industry.
                            </p>
                            </div>
                            <div className="challenge-details">
                            <div className="icon">
                                <i className="fa-solid fa-check" />
                            </div>
                            <p className="description">
                                We tailor solutions that align with your financial and operational goals.
                            </p>
                            </div>
                            <div className="challenge-details">
                            <div className="icon">
                                <i className="fa-solid fa-check" />
                            </div>
                            <p className="description">
                                Our audit, VAT, and ERP experience ensures regulatory accuracy.
                            </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="challenge-details">
                            <div className="icon">
                                <i className="fa-solid fa-check" />
                            </div>
                            <p className="description">
                                You gain clarity and direction through our structured consulting process.
                            </p>
                            </div>
                            <div className="challenge-details">
                            <div className="icon">
                                <i className="fa-solid fa-check" />
                            </div>
                            <p className="description">
                                We ensure transparency and compliance at every stage of your business growth.
                            </p>
                            </div>
                            <div className="challenge-details">
                            <div className="icon">
                                <i className="fa-solid fa-check" />
                            </div>
                            <p className="description">
                               We’re more than advisors — we’re your long-term financial partners.
                            </p>
                            </div>
                        </div>
                        </div>
                        <p style={{textAlign:"justify"}} className="description mt--30">
                       AQ Audit brings deep industry knowledge, regulatory expertise, and scalable service models. We empower clients like GreenEdge Holdings with precision, confidence, and a strong financial foundation.
                        </p>
                        <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="thumbnail">
                            <img
                                src="assets/images/projects-details/challen-1.jpg"
                                alt="project details"
                            />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="thumbnail">
                            <img
                                src="assets/images/projects-details/challen-2.jpg"
                                alt="project details"
                            />
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        {/* Start Projects Details area  */}

            <Footer/>
        </>
        

    </div>
  )
}

export default PortfolioSix